/**
 * The sign-in password rules, as ASP.NET Identity checks them (its defaults, as for instructors): 6+ characters,
 * an uppercase letter (char.IsUpper), a lowercase letter (char.IsLower), a digit (char.IsDigit) and a character
 * that is neither a letter nor a digit, all Unicode-aware, so a Cyrillic password passes here as it does there.
 */
export const meetsPasswordRules = (password: string): boolean =>
  password.length >= 6 &&
  /\p{Ll}/u.test(password) &&
  /\p{Lu}/u.test(password) &&
  /\p{Nd}/u.test(password) &&
  /[^\p{L}\p{Nd}]/u.test(password);
